import { Map } from 'immutable';
import get from 'lodash/get';

import * as AudioPlayerConstants from '../constants/AudioPlayer';

export function browserAutoplayBlockedPattern(action) {
  return (
    action.type === AudioPlayerConstants.AudioPlayerActions.ERROR &&
    get(action, 'data.ERROR_OBJ.commonType') ===
      AudioPlayerConstants.CommonAudioErrorCodes.BROWSER_AUTOPLAY_BLOCKED
  );
}

export function trackEndErrorUnrecoverablePattern(action) {
  return (
    action.type === AudioPlayerConstants.AudioPlayerActions.TRACK_END_ERROR &&
    !get(action, 'data.isRecoverable', true)
  );
}

export function getAudioContentHost(audioUrl) {
  return /pandora\.com|p-cdn\.com|p-cdn\.us|savagebeast\.com/.test(audioUrl)
    ? AudioPlayerConstants.AudioContentHost.INTERNAL
    : AudioPlayerConstants.AudioContentHost.EXTERNAL;
}

export function isTrackEncrypted(track) {
  return Map.isMap(track) && !!track.get('key');
}
